import { Grid, Paper, Typography } from "@mui/material"
import React from "react"
import CollectionLog from "./CollectionLog"
import CollectionMap from "./CollectionMap"
import FileUpload from "./UploadFile"

export default function Collection() {
  return (
    <Grid container spacing={4} style={{ padding: 20 }}>
      <Grid item xs={12}>
        <Typography variant="h2" gutterBottom>
          Seaweed Collection
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h4" gutterBottom>
            Collection Boundaries
          </Typography>
          <CollectionMap />
        </Paper>
      </Grid>

      <Grid item xs={12} md={4}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h4" gutterBottom>
            Exemption directions:
          </Typography>
          <Typography variant="Body">
            The Exemption holder must advise the DPIRD by calling 1300 278 292
            at least 48 hours prior to commencing each collection trip under
            this exemption, of the:
            <br />
            a) first name of person collecting;
            <br />
            b) surname of person collecting;
            <br />
            c) contact number;
            <br />
            d) nearest DPIRD Office;
            <br />
            e) further location;
            <br />
            f) exemption number;
            <br />
            g) exemption collection trip start date;
            <br />
            h) exemption collection trip start time;
            <br />
            i) exemption collection trip end date;
            <br />
            j) exemption collection trip end time;
            <br />
            k) vehicle/vessel registration/name;
            <br />
            l) species targeted; and
            <br />
            m) numbers exempt;
            <br />
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h4" gutterBottom>
            Download:
          </Typography>
          <a
            href={
              process.env.PUBLIC_URL +
              "files/CFA - signed exemption 8 11 22.pdf"
            }
            download
          >
            Click to download exemption.
          </a>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h4">Collection Log:</Typography>
          <CollectionLog />
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h4" gutterBottom>
            Upload:
          </Typography>
          <Typography variant="Body">
            Upload a photo of your collection log here:
          </Typography>
          <FileUpload />
        </Paper>
      </Grid>
    </Grid>
  )
}
